import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import logoBlack from '../../assets/logo/Humphree Trim and Stabilization black.png';
import logoWhite from '../../assets/logo/Humphree Trim and Stabilization white.png';
import { useTheme } from '../../contexts/ThemeContext';
import Sidebar from './Sidebar';

function Layout() {
  const { resolvedTheme } = useTheme();
  const [showMenu, setShowMenu] = useState(window.innerWidth >= 768 ? true : false);

  return (
    <div className='bg-white text-black h-screen flex flex-grow'>
      <Sidebar setShowMenu={setShowMenu} showMenu={showMenu} />
      <div className='relative flex flex-col md:px-2 2xl:px-20 md:py-2 2xl:py-14 w-full overflow-y-auto'>
        {/* Hamburger */}
        <div className='sticky flex top-0 w-full z-50 pr-4 bg-gray-5 shadow-popup md:hidden'>
          <div
            className={`transition duration-500 ${showMenu ? 'text-black bg-white' : 'bg-black text-white'} p-4`}
            onClick={() => setShowMenu(!showMenu)}
          >
            <FontAwesomeIcon icon={faBars} size='2x' />
          </div>
          <div className='flex ml-auto max-w-[15rem] cursor-pointer' onClick={() => (window.location.pathname = '/')}>
            <img
              src={resolvedTheme === 'light' ? logoBlack : logoWhite}
              className='object-contain'
              alt='Humphree logo'
            />
          </div>
        </div>
        <div className='m-6 max-w-[1500px]'>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
